import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f5b3f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-wrapper" }
const _hoisted_2 = { class: "process-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"margin-top":"24px","padding-bottom":"24px"}
}
const _hoisted_4 = { class: "help-file-wrapper" }
const _hoisted_5 = { class: "process-Title-tip" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-tip-content" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"width":"102%","display":"inline-block"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "分、子公司注册完成后，请将租赁合同以新注册分、子公司名义换签后将合同扫描件回传！")
  ])
], -1))
const _hoisted_8 = { style: {"margin":"24px auto 20px"} }
const _hoisted_9 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_10 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_11 = { class: "location-steps" }
const _hoisted_12 = { class: "content-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("银行打款")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("支付宝打款")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("微信打款")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_18 = {
  key: 3,
  class: "flow-box"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确定要重新申请吗?", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 提交重新申请后，则代表 ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600"} }, "【选址申请——房屋租赁等合同审核——装修采购协议审核】", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 三个模块的所有申请均重置！ ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600"} }, "若有已申请的文件将会失效，注意确认", -1))

import {
  ref,
  reactive,
  computed,
  withDefaults,
  watch,
  watchEffect,
} from "vue";
import { USERLIST } from "../../const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import Approval from "@/components/Approval.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import { message } from "ant-design-vue";

import { FileType, File, NodeItem } from "../../types/procss";
import Image from "../../components/Image.vue";
import type { FormInstance } from "ant-design-vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import {
  siteSelectionDetail,
  submitSiteSelectionApply,
  recallSiteSelectionApply,
  editSiteSelectionApply,
  houseRentDetail,
  submitHouseRentApply,
  editHouseRentApply,
  recallHouseRentApply,
  turnaroundHouseRentApply,
  decproDetail,
  submitdecproApply,
  editDecproApply,
  recallDecproApply,
  turnaroundDecproApply,
  recallTurnaroundHouseRentApply,
  recallTurnaroundDecproApply,
  siteSelectionReapply,
} from "../../api/process";
import { nextTick } from "vue";
import HouseRentApplyDetail from "./HouseRent/detail.vue";
import { GetCurrentMyPageList } from "@/api/index";
import { isEmpty, towDecimal, minCompare, maxCompare } from "@/utils/type";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow", "reapplyOk"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const actionButtons = ref<(string | number)[]>([]); //默认是申请审批
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识

const WorkFlowId = ref<number>(0);

const edit = computed(() => actionButtons.value.includes("100"));
const recallVisible = ref<boolean>(false);
const recallVisible1 = ref<boolean>(false);
const recallVisible2 = ref<boolean>(false);

let turnRentVisible = ref<boolean>(false);
let turnDecproVisible = ref<boolean>(false);
const siteSelectiofFormRef = ref<FormInstance>(); //选址表单
const houseRentFormRef = ref<FormInstance>(); //房屋租赁
const decproFormRef = ref<FormInstance>(); //装修及采购
const turnFormRef = ref<FormInstance>(); //房屋租赁回传
const turnDecproFormRef = ref<FormInstance>(); //装修及采购回传
const isEditFile = ref<boolean>(false); //文件是否可编辑
const IsSQWTEdit = ref<boolean>(false); //授权委托是否可编辑 true可编辑
const IsZLBAEdit = ref<boolean>(false); //租赁备案是否可编辑 true可编辑
const IsWYXYEdit = ref<boolean>(false); //租赁备案是否可编辑 true可编辑
const IsFirstZLBAEdit = ref<boolean>(false); //是否第一次上传租赁备案
const IsFirstSQWTEdit = ref<boolean>(false); //是否第一次上传授权委托
const IsFirstWYXYEdit = ref<boolean>(false); //是否第一次上传物业协议
const IsFirstFWZLEdit = ref<boolean>(false); //是否第一次上传房屋租赁
const IsFirstCGEdit = ref<boolean>(false); //是否第一次上传采购

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);
let currentStep = ref<number>(0);
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const firstIn = ref<boolean>(true);
const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const route = useRoute();
const { query } = route;
const id = ref(query.id || "");

const checkFormRef = ref<FormInstance>();


watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;
      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value =
        currentData.value?.Code == "301"
          ? 0
          : currentData.value?.Code == "302"
          ? 1
          : 2;
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "3");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value =
            currentData.value?.Code == "301"
              ? 0
              : currentData.value?.Code == "302"
              ? 1
              : 2;
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});



let siteSelection = reactive<Record<string, any>>({
  PageFiles: [],
  BranchCompanyFlowId: 0,
});

let houseRent = reactive<Record<string, any>>({
  PageFiles: [],
  // BackPageFiles: []
});

let decpro = reactive<Record<string, any>>({
  PageFiles: [],
});

let turn = reactive<Record<string, any>>({
  PageFiles: [],
});
let turnDecpro = reactive<Record<string, any>>({
  PageFiles: [],
});

const Reason1 = ref<string>();
const Reason2 = ref<string>();

let form = ref({
  Address: "",
  BusinessRegistrationAddress: "",
  Deposit: "",
  Rent: "",
  Area: "",
  CapacityNumber: "",
  LeaseDate: [],
  LeaseStartDate: null,
  LeaseEndDate: null,
  LandlordContact: "",
  PaymentAccount: "",
  IsSettleIndustrialPark: undefined,
  PaymentWay: 1,
});

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "集团行政篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230526/20230526_221034898181947_集团行政篇.pdf",
  },
  {
    title: "集团法务篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184419114791550_集团法务篇.pdf",
  },
];

const tableData = [
  // {
  //   depart: "综合管理中心",
  //   name: "张思然",
  //   duty: "公司选址及装修咨询",
  //   email: "siran.zhang@risfond.com",
  //   phone: "13521222804",
  // },
  {
    depart: "风控合规中心",
    name: "郑晓雪",
    duty: "租房合同审批、用章申请、资料提供",
    email: "xiaoxue.zheng@risfond.com",
    phone: "13911699671",
  },
  {
    depart: "财务管理中心",
    name: "张馨予",
    duty: "财务支持全模",
    email: "Zhangxinyu@risfond.com",
    phone: "15010170908",
  },
];
const list = [
  "提交选址申请",
  "提交房屋租赁合同、房产证复印件资料审核；若有以下资料，提交租赁备案、授权委托书审核",
  "回传房屋租赁签订合同",
  "若有以下资料，提交房屋装修协议、办公用品采购协议审核",
];
const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 14 },
};
const recallResume = ref<string>("");

const handleCancelResume = () => {
  recallResume.value = "";
  Reason1.value = "";
  Reason2.value = "";
  recallVisible.value = false;

  recallVisible1.value = false;
  recallVisible2.value = false;
};
//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (currentStep.value == 0) {
      siteSelection.PageFiles = [];
    } else if (currentStep.value == 1) {
      if (turnRentVisible.value) {
        turn.PageFiles[index as number] = "";
      } else {
        if (index == 0 || index == 1) {
          houseRent.PageFiles[index as number] = "";
        } else {
          houseRent.PageFiles[index as number] = {
            FileName: "",
            FileUrl: "",
            AccessoryType: index == 2 ? 323 : index == 3 ? 324 : 325,
          };
        }
      }
    } else {
      if (turnDecproVisible.value) {
        turnDecpro.PageFiles[index as number] = "";
      } else {
        decpro.PageFiles[index as number] = {
          FileName: "",
          FileUrl: "",
          AccessoryType: index == 0 ? 331 : 332,
        };
      }
    }
  } else {
    if (currentStep.value == 0) {
      siteSelection.PageFiles = [
        {
          ...file,
          FileUrl: file.Url,
        },
      ];
    } else if (currentStep.value == 1) {
      if (turnRentVisible.value) {
        turn.PageFiles[index as number] = {
          ...file,
          FileUrl: file.Url,
        };
      } else {
        if (
          index == 2 &&
          (!houseRent.PageFiles[index] || !houseRent.PageFiles[index].FileUrl)
        ) {
          IsFirstZLBAEdit.value = true; //是否第一次提交
        }
        if (
          index == 3 &&
          (!houseRent.PageFiles[index] || !houseRent.PageFiles[index].FileUrl)
        ) {
          IsFirstSQWTEdit.value = true; //是否第一次提交
        }
        if (
          index == 4 &&
          (!houseRent.PageFiles[index] || !houseRent.PageFiles[index].FileUrl)
        ) {
          IsFirstWYXYEdit.value = true; //是否第一次提交
        }
        houseRent.PageFiles[index] = {
          ...file,
          FileUrl: file.Url,
        };
      }
    } else {
      if (turnDecproVisible.value) {
        turnDecpro.PageFiles[index as number] = {
          ...file,
          FileUrl: file.Url,
        };
      } else {
        if (
          index == 0 &&
          (!decpro.PageFiles[index] || !decpro.PageFiles[index].FileUrl)
        ) {
          IsFirstFWZLEdit.value = true; //是否第一次提交
        }
        if (
          index == 1 &&
          (!decpro.PageFiles[index] || !decpro.PageFiles[index].FileUrl)
        ) {
          IsFirstCGEdit.value = true; //是否第一次提交
        }
        decpro.PageFiles[index] = {
          ...file,
          FileUrl: file.Url,
        };
      }
    }
  }
};
// ---房屋选址开始---

//提交申请
const submitSiteSelection = () => {
  siteSelectiofFormRef.value?.validate().then(async (res) => {
    //提交申请
    const { Success, Message } = await submitSiteSelectionApply({
      PageFiles: siteSelection.PageFiles,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
//撤回申请
const submitRecallSiteSelectionApply = async () => {
  if (!recallResume.value) {
    message.error("请输入撤回理由");
    return;
  }
  let method = recallSiteSelectionApply;
  let callback = getSiteSelectInfo;
  if (currentStep.value == 1) {
    method = recallHouseRentApply;
    callback = gethouseRentInfo;
  } else if (currentStep.value == 2) {
    method = recallDecproApply;
    callback = getDecproDetail;
  }
  const { Success, Message } = await method({
    Reason: recallResume.value,
    BusinessFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("已撤回审核");
    callback();
    recallVisible.value = false;
    $emit("update-flow");
    handleCancelResume();
  } else {
    message.error(Message || "撤回失败，请稍后重试");
    handleCancelResume();
  }
};

//重新提交
const submitEditSiteSelectionApply = async () => {
  siteSelectiofFormRef.value?.validate().then(async (res) => {
    const { Success, Message } = await editSiteSelectionApply({
      PageFiles: siteSelection.PageFiles,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.success(Message || "提交失败，请稍后重试");
    }
  });
};
// ---房屋选址结束---

// ---房屋租赁开始---
const handlePaymentAccountInput = (e: any) => {
  const o = e.target;
  const value = o.value.toString();
  nextTick(() => {
    form.value.PaymentAccount = value
      .replace(/\D/g, "")
      .replace(/(\d{4})(?=\d)/g, "$1 ");
  });
};
// 租赁起始时间
const handleLeaseDate = (e: any) => {
  if (e) {
    form.value.LeaseStartDate = e[0];
    form.value.LeaseEndDate = e[1];
  } else {
    form.value.LeaseDate = [];
    form.value.LeaseStartDate = null;
    form.value.LeaseEndDate = null;
  }
};

// 校验打款帐号
const validateBankNum = (rule, value, callback: any) => {
  const regExp = /\d{5}|\d{30}/;
  if (isEmpty(value)) {
    return Promise.reject("请输入打款账号");
  } else if (!regExp.test(value.replace(/\s*/g, ""))) {
    return Promise.reject("请输入5-30位的打款账号");
  } else {
    return Promise.resolve();
  }
};

// 校验人、月
const validatePeopleOrMonth = (rule, value, callback: any) => {
  const regExp = /^[+]{0,1}(\d+)$/;
  if (value && !regExp.test(value)) {
    return Promise.reject("请输入正整数");
  } else {
    return Promise.resolve();
  }
};
//提交申请
const submitHouseRent = () => {
  if (checkFormRef.value) {
    checkFormRef.value?.validateFields().then(async (res) => {
      houseRentFormRef.value?.validate().then(async (res) => {
        let _file = houseRent.PageFiles.filter(
          (item: File) => item.FileUrl || item.Url
        );
        //提交申请
        if (turn.PageFiles.length > 0) {
          _file = [...turn.PageFiles, ...houseRent.PageFiles];
        }
        const { Success, Message } = await submitHouseRentApply({
          Data: {
            Address: form.value.Address,
            BusinessRegistrationAddress: form.value.BusinessRegistrationAddress,
            Deposit: form.value.Deposit,
            Rent: form.value.Rent,
            Area: form.value.Area,
            CapacityNumber: form.value.CapacityNumber,
            LeaseStartDate: form.value.LeaseStartDate,
            LeaseEndDate: form.value.LeaseEndDate,
            LandlordContact: form.value.LandlordContact,
            PaymentAccount: form.value.PaymentAccount,
            IsSettleIndustrialPark: form.value.IsSettleIndustrialPark,
            PaymentWay: form.value.PaymentWay,
          },
          PageFiles: _file, //因为有非必填项 所以要筛选
          BranchCompanyFlowId: BranchCompanyFlowId.value,
        });
        if (Success) {
          message.success("已提交审核");
          $emit("update-flow");
        } else {
          message.error(Message || "提交失败，请稍后重试");
        }
      });
    });
  } else {
    houseRentFormRef.value?.validate().then(async (res) => {
      let _file = houseRent.PageFiles.filter(
        (item: File) => item.FileUrl || item.Url
      );
      //提交申请
      if (turn.PageFiles.length > 0) {
        _file = [...turn.PageFiles, ...houseRent.PageFiles];
      }
      const { Success, Message } = await submitHouseRentApply({
        PageFiles: _file, //因为有非必填项 所以要筛选
        BranchCompanyFlowId: BranchCompanyFlowId.value,
      });
      if (Success) {
        message.success("已提交审核");
        $emit("update-flow");
      } else {
        message.error(Message || "提交失败，请稍后重试");
      }
    });
  }
};

//重新提交
const submitEditHouseRentApply = async () => {
  let _file = houseRent.PageFiles.filter(
    (item: File) => item.FileUrl || item.Url
  );
  //提交申请
  if (turn.PageFiles.length > 0) {
    _file = [...turn.PageFiles, ...houseRent.PageFiles];
  }
  if (checkFormRef.value) {
    checkFormRef.value?.validateFields().then(async (res) => {
      houseRentFormRef.value?.validate().then(async (res) => {
        const { Success, Message } = await editHouseRentApply({
          Data: {
            Address: form.value.Address,
            BusinessRegistrationAddress: form.value.BusinessRegistrationAddress,
            Deposit: form.value.Deposit,
            Rent: form.value.Rent,
            Area: form.value.Area,
            CapacityNumber: form.value.CapacityNumber,
            LeaseStartDate: form.value.LeaseStartDate,
            LeaseEndDate: form.value.LeaseEndDate,
            LandlordContact: form.value.LandlordContact,
            PaymentAccount: form.value.PaymentAccount,
            IsSettleIndustrialPark: form.value.IsSettleIndustrialPark,
            PaymentWay: form.value.PaymentWay,
          },
          PageFiles: _file, //因为有非必填项 所以要筛选,
          BranchCompanyFlowId: BranchCompanyFlowId.value,
        });
        if (Success) {
          message.success("已提交审核");
          gethouseRentInfo();
          $emit("update-flow");
          reEdit.value = false;
        } else {
          message.success(Message || "提交失败，请稍后重试");
        }
      });
    });
  } else {
    houseRentFormRef.value?.validate().then(async (res) => {
      const { Success, Message } = await editHouseRentApply({
        PageFiles: _file, //因为有非必填项 所以要筛选,
        BranchCompanyFlowId: BranchCompanyFlowId.value,
      });
      if (Success) {
        message.success("已提交审核");
        gethouseRentInfo();
        $emit("update-flow");
        reEdit.value = false;
      } else {
        message.success(Message || "提交失败，请稍后重试");
      }
    });
  }
};
// todo： 回传
const submitTurnaroundHouseRentApply = async () => {
  turnFormRef.value?.validate().then(async (res) => {
    const { Success, Message } = await turnaroundHouseRentApply({
      PageFiles: turn.PageFiles,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交回传");
      $emit("update-flow");
      turnRentVisible.value = false;
    } else {
      turnRentVisible.value = false;
      gethouseRentInfo();
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

// ---房屋租赁结束---

// ---装修及采购协议---

//提交申请
const submitDecpro = () => {
  decproFormRef.value?.validate().then(async (res) => {
    //提交申请
    let _file = decpro.PageFiles.filter(
      (item: File) => item.FileUrl || item.Url
    );
    //提交申请
    if (turnDecpro.PageFiles.length > 0) {
      _file = [...turnDecpro.PageFiles, ...decpro.PageFiles];
    }
    const { Success, Message } = await submitdecproApply({
      PageFiles: _file, //因为有非必填项 所以要筛选,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

//重新提交
const submitEditDecproApply = async () => {
  let _file = decpro.PageFiles.filter((item: File) => item.FileUrl || item.Url);
  //提交申请
  if (turnDecpro.PageFiles.length > 0) {
    _file = [...turnDecpro.PageFiles, ...decpro.PageFiles];
  }
  decproFormRef.value?.validate().then(async (res) => {
    const { Success, Message } = await editDecproApply({
      PageFiles: _file, //因为有非必填项 所以要筛选,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.success(Message || "提交失败，请稍后重试");
    }
  });
};
// todo： 回传
const submitTurnaroundDecproApply = async () => {
  turnDecproFormRef.value?.validate().then(async (res) => {
    const { Success, Message } = await turnaroundDecproApply({
      PageFiles: turnDecpro.PageFiles,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交回传");
      turnDecproVisible.value = false;
      $emit("update-flow");
    } else {
      getDecproDetail();
      turnDecproVisible.value = false;
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const handleReSubmit = () => {
  //重新提交申请
  if (currentStep.value == 0) {
    submitEditSiteSelectionApply();
  } else if (currentStep.value == 1) {
    submitEditHouseRentApply();
  } else {
    submitEditDecproApply();
  }
};

// 装修采购审批协议结束

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    IsFirstZLBAEdit.value = false;
    IsFirstSQWTEdit.value = false;
    IsFirstFWZLEdit.value = false;
    IsFirstCGEdit.value = false;
    IsFirstWYXYEdit.value = false;
    if (currentStep.value == 0) {
      submitSiteSelection();
    } else if (currentStep.value == 1) {
      submitHouseRent();
    } else {
      submitDecpro();
    }
  } else if (buttonType == "101") {
    //撤回申请
    recallVisible.value = true;
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "201") {
    //房屋租赁回传回传
    turnRentVisible.value = true;
  } else if (buttonType == "202") {
    recallVisible1.value = true; //撤回回传
    //撤回回传
  } else if (buttonType == "302") {
    recallVisible2.value = true;
  } else if (buttonType == "301") {
    //装修回传
    turnDecproVisible.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    applyOnOkVisible.value = true;
  } else if (buttonType == "-1") {
    reEdit.value = false;
    if (currentStep.value == 0) {
      getSiteSelectInfo();
    } else if (currentStep.value == 1) {
      gethouseRentInfo();
    } else {
      getDecproDetail();
    }
  } else if (buttonType == "-2") {
    IsFirstZLBAEdit.value = false;
    IsFirstSQWTEdit.value = false;
    IsFirstFWZLEdit.value = false;
    IsFirstCGEdit.value = false;
    IsFirstWYXYEdit.value = false;
    handleReSubmit();
  }
  // 305	选址及房屋租赁重新申请
  else if (buttonType == "305") {
    applyModalShow.value = true;
  }
};

//撤回回传
const setRecallTurnaroundHouseRentApply = async () => {
  let callback;
  if (currentStep.value == 1) {
    callback = recallTurnaroundHouseRentApply;
  } else {
    callback = recallTurnaroundDecproApply;
  }
  let reason = currentStep.value == 1 ? Reason1.value : Reason2.value;
  if (!reason) {
    message.error("请输入撤回理由");
    return;
  }
  const { Data, Success } = await callback({
    BusinessFlowId: BranchCompanyFlowId.value,
    Reason: reason,
  });
  if (Success) {
    if (currentStep.value == 1) {
      gethouseRentInfo();
    } else {
      getDecproDetail();
    }
    $emit("update-flow");
    handleCancelResume();
    message.success("已撤回");
  } else {
    handleCancelResume();
    message.error("撤回失败，请稍后重试");
  }
};

const getSiteSelectInfo = async () => {
  const { Data } = await siteSelectionDetail({ Id: BranchCompanyFlowId.value });
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageFiles.length > 0) {
    siteSelection.PageFiles = Data?.PageFiles;
  } else {
    siteSelection.PageFiles = [];
  }
  WorkFlowId.value = Data?.WorkFlowId;
};

const gethouseRentInfo = async () => {
  const { Data } = await houseRentDetail({ Id: BranchCompanyFlowId.value });
  actionButtons.value = Data?.ActionButtons || [];
  isEditFile.value = Data.IsEdit;
  IsSQWTEdit.value = Data?.IsSQWTEdit;
  IsZLBAEdit.value = Data?.IsZLBAEdit;
  IsWYXYEdit.value = Data?.IsWYXYEdit;
  if (Data?.PageFiles.length > 0) {
    let _list = Data?.PageFiles.slice();
    let _ZLBA = Data?.PageFiles.find((item) => {
      return +item.AccessoryType == 323;
    });
    if (!_ZLBA) {
      _list[2] = {
        AccessoryType: "323",
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[2] = _ZLBA;
    }

    let _SQWT = Data?.PageFiles.find((item) => {
      return +item.AccessoryType == 324;
    });
    if (!_SQWT) {
      _list[3] = {
        AccessoryType: "324",
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[3] = _SQWT;
    }
    // 物业协议（若有）---新增
    let _WYXY = Data?.PageFiles.find((item) => {
      return +item.AccessoryType == 325;
    });
    if (!_WYXY) {
      _list[4] = {
        AccessoryType: "325",
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[4] = _WYXY;
    }

    houseRent.PageFiles = _list;
  } else {
    houseRent.PageFiles = [
      { AccessoryType: "321", FileName: "", FileUrl: "" },
      { AccessoryType: "322", FileName: "", FileUrl: "" },
      {
        AccessoryType: "323",
        FileName: "",
        FileUrl: "",
      },
      {
        AccessoryType: "324",
        FileName: "",
        FileUrl: "",
      },
      {
        AccessoryType: "325",
        FileName: "",
        FileUrl: "",
      },
    ];
  }
  if (Data?.BackPageFiles.length == 0) {
    turn.PageFiles = [
      {
        AccessoryType: "3211",
        FileName: "",
        FileUrl: "",
      },
    ];
  } else {
    turn.PageFiles = Data?.BackPageFiles;
  }
  form.value = Data?.Data || {};
  form.value.IsSettleIndustrialPark =
    Data?.Data?.IsSettleIndustrialPark.toString();
  form.value.LeaseDate = [Data?.Data?.LeaseStartDate, Data?.Data?.LeaseEndDate];
  form.value.Rent = Data?.Data?.Rent.toString();
  form.value.Deposit = Data?.Data?.Deposit.toString();
  form.value.Area = Data?.Data?.Area.toString();
  form.value.CapacityNumber = Data?.Data?.CapacityNumber.toString();
  form.value.PaymentWay = Data?.Data?.PaymentWay || 1;
  WorkFlowId.value = Data?.WorkFlowId;
};

const getDecproDetail = async () => {
  const { Data } = await decproDetail({ Id: BranchCompanyFlowId.value });
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageFiles.length > 0) {
    let _list = Data?.PageFiles.slice();
    let _ZLBA = Data?.PageFiles.find((item) => {
      return +item.AccessoryType == 331;
    });
    if (!_ZLBA) {
      _list[0] = {
        AccessoryType: "331",
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[0] = _ZLBA;
    }

    let _SQWT = Data?.PageFiles.find((item) => {
      return +item.AccessoryType == 332;
    });
    if (!_SQWT) {
      _list[1] = {
        AccessoryType: "332",
        FileName: "",
        FileUrl: "",
      };
    } else {
      _list[1] = _SQWT;
    }
    decpro.PageFiles = _list;
  } else {
    decpro.PageFiles = [
      { AccessoryType: "331", FileName: "", FileUrl: "" },
      { AccessoryType: "332", FileName: "", FileUrl: "" },
    ];
  }
  if (Data?.BackPageFiles.length == 0) {
    turnDecpro.PageFiles = [
      {
        AccessoryType: "3311",
        FileName: "",
        FileUrl: "",
      },
      {
        AccessoryType: "3321",
        FileName: "",
        FileUrl: "",
      },
    ];
  } else {
    turnDecpro.PageFiles = Data?.BackPageFiles;
  }
  WorkFlowId.value = Data?.WorkFlowId;
  isEditFile.value = Data.IsEdit;
};
// 切换tab
const handleTabChange = (index: number) => {
  reEdit.value = false;
  if (index == 0) {
    BranchCompanyFlowId.value = filterCompanyCode("301");
    getSiteSelectInfo();
  } else if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("302");
    gethouseRentInfo();
    // reEdit.value = false;
  } else {
    BranchCompanyFlowId.value = filterCompanyCode("303");
    getDecproDetail();
  }
};

const filterCompanyCode = (code: string) => {
  WorkFlowId.value = 0;
  const { id, type } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    preData.value = props.flowData.find(
      (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
    );
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};

const handleRejectback = () => {
  rejectedVisible.value = false;
  $emit("update-flow");
  getList();
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  $emit("update-flow");
  getList();
};

const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

//正整数校验
const validateNum = async (_rule: any, value: string, text: string) => {
  if (isEmpty(value)) {
    return Promise.reject(`请输入${text}`);
  } else if (!minCompare(value, "1") || !maxCompare(value, "999999")) {
    return Promise.reject("请输入1-999999之间的整数");
  } else {
    return Promise.resolve();
  }
};

//小数点两位的校验
const validateNum2 = async (
  _rule: any,
  value: string,
  text: string,
  min: string
) => {
  if (isEmpty(value)) {
    return Promise.reject(`请输入${text}`);
  } else if (!towDecimal(value)) {
    return Promise.reject("最多输入2位小数");
  } else if (!minCompare(value, min) || !maxCompare(value, "999999")) {
    return Promise.reject(`请输入${min}-999999之间的数`);
  } else {
    return Promise.resolve();
  }
};
const applyModalShow = ref<boolean>(false);
const reapplyOk = () => {
  $emit("reapplyOk", true);
  siteSelectionReapply({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  })
    .then((res) => {
      if (res.Success) {
        message.success("重新申请成功");
        getSiteSelectInfo();
        $emit("update-flow");
      } else {
        message.error(res.Message || "撤回失败，请稍后重试");
      }
    })
    .finally(() => {
      reapplyCancel();
      $emit("reapplyOk", false);
    });
};
const reapplyCancel = () => {
  applyModalShow.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "提交选址及房屋租赁等合同审核" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 190,
          height: 130
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "选址及房屋租赁合同注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "tip-icon",
              src: require('../../assets/imgs/ProcessNode/warning-tip.png')
            }, null, 8, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_steps, {
                  class: "bussiness-step bank-steps",
                  current: _unref(currentStep),
                  "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentStep) ? (currentStep).value = $event : currentStep = $event)),
                  size: "small",
                  onChange: handleTabChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_step, {
                      title: "选址申请",
                      status: _unref(currentStep) == 0 ? 'process' : 'wait'
                    }, null, 8, ["status"]),
                    _createVNode(_component_a_step, {
                      title: "房屋租赁等合同审核",
                      status: _unref(currentStep) == 1 ? 'process' : 'wait'
                    }, null, 8, ["status"]),
                    _createVNode(_component_a_step, {
                      title: "装修、采购协议审核",
                      status: _unref(currentStep) == 2 ? 'process' : 'wait'
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                }, 8, ["current"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_unref(currentStep) == 0)
                  ? (_openBlock(), _createBlock(_component_a_form, _mergeProps({
                      key: 0,
                      ref_key: "siteSelectiofFormRef",
                      ref: siteSelectiofFormRef,
                      model: _unref(siteSelection)
                    }, formItemLayout, {
                      validateTrigger: "blur",
                      class: 
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: ['PageFiles', 0, 'FileUrl'],
                          label: "选址",
                          required: "",
                          class: "form-upload-item",
                          rules: [{ required: true, message: '请上传选址文件' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                    _unref(siteSelection).PageFiles.length > 0
                      ? _unref(siteSelection).PageFiles[0].FileUrl
                      : ''
                  ,
                              "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                              disable: !!preData.value,
                              onUpload: handleUpload,
                              "file-type": '311',
                              "download-link": {
                    filename: '选址.xlsx',
                    fileKey: '3011',
                  }
                            }, null, 8, ["value", "disable-close", "disable", "download-link"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["model", "class"]))
                  : _createCommentVNode("", true),
                (_unref(currentStep) == 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (
                (id.value && _unref(personInfo).IsCreate == 0 && !_unref(form).Address) ||
                WorkFlowId.value == 0 ||
                (isEditFile.value && reEdit.value)
              )
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            class: "location-form-wrapper",
                            ref_key: "checkFormRef",
                            ref: checkFormRef,
                            model: _unref(form),
                            layout: "inline",
                            trigger: "change"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "地址",
                                class: "location-form-item",
                                name: ['Address'],
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 200,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_textarea, {
                                    value: _unref(form).Address,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).Address) = $event)),
                                    placeholder: "请输入",
                                    "auto-size": ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "工商注册地址",
                                class: "location-form-item",
                                name: "BusinessRegistrationAddress",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 200,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_textarea, {
                                    value: _unref(form).BusinessRegistrationAddress,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).BusinessRegistrationAddress) = $event)),
                                    placeholder: "请输入",
                                    "auto-size": ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "租金(含物业费)/月",
                                class: "location-form-item",
                                name: "Rent",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      validator: (_rule, value) =>
                        validateNum2(_rule, value, '租金(含物业费)/月', '0'),
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).Rent,
                                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).Rent) = $event)),
                                    placeholder: "请输入",
                                    suffix: "元",
                                    maxlength: 9
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_a_form_item, {
                                label: "押金",
                                class: "location-form-item",
                                name: "Deposit",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      validator: (_rule, value) =>
                        validateNum2(_rule, value, '押金', '0'),
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).Deposit,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).Deposit) = $event)),
                                    placeholder: "请输入",
                                    suffix: "元",
                                    maxlength: 9
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_a_form_item, {
                                label: "面积",
                                class: "location-form-item",
                                name: "Area",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      validator: (_rule, value) =>
                        validateNum2(_rule, value, '面积', '1'),
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).Area,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).Area) = $event)),
                                    placeholder: "请输入",
                                    suffix: "平方米",
                                    maxlength: 9
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_a_form_item, {
                                label: "可容纳人数",
                                class: "location-form-item",
                                name: "CapacityNumber",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      validator: (_rule, value) =>
                        validateNum(_rule, value, '可容纳人数'),
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).CapacityNumber,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).CapacityNumber) = $event)),
                                    placeholder: "请输入",
                                    suffix: "人",
                                    oninput: "value=value.replace(/^\\.+|[^\\d]+/g,'')",
                                    maxlength: 6
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["rules"]),
                              _createVNode(_component_a_form_item, {
                                label: "租赁起止时间",
                                class: "location-form-item",
                                name: "LeaseDate",
                                required: "",
                                colon: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_range_picker, {
                                    style: {"width":"100%"},
                                    value: _unref(form).LeaseDate,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).LeaseDate) = $event)),
                                    placeholder: ['开始时间', '结束时间'],
                                    valueFormat: "YYYY-MM-DD",
                                    onChange: handleLeaseDate
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "房东联系方式",
                                class: "location-form-item",
                                name: "LandlordContact",
                                required: "",
                                colon: false,
                                rules: [{ required: true, message: '请输入房东联系方式' }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).LandlordContact,
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).LandlordContact) = $event)),
                                    placeholder: "请输入",
                                    maxlength: 30
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "打款方式",
                                class: "location-form-item",
                                name: "PaymentWay",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      trigger: 'change',
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _unref(form).PaymentWay,
                                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).PaymentWay) = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select_option, { value: 1 }, {
                                        default: _withCtx(() => [
                                          _hoisted_13
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: 2 }, {
                                        default: _withCtx(() => [
                                          _hoisted_14
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: 3 }, {
                                        default: _withCtx(() => [
                                          _hoisted_15
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "打款账号",
                                class: "location-form-item",
                                name: "PaymentAccount",
                                colon: false,
                                rules: [
                    {
                      required: true,
                      trigger: 'blur',
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).PaymentAccount,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).PaymentAccount) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "是否入驻产业园",
                                class: "location-form-item",
                                name: "IsSettleIndustrialPark",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _unref(form).IsSettleIndustrialPark,
                                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).IsSettleIndustrialPark) = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select_option, { value: "1" }, {
                                        default: _withCtx(() => [
                                          _hoisted_16
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "2" }, {
                                        default: _withCtx(() => [
                                          _hoisted_17
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : (_openBlock(), _createBlock(HouseRentApplyDetail, {
                            key: 1,
                            detail: { ..._unref(form) },
                            "folw-id": BranchCompanyFlowId.value
                          }, null, 8, ["detail", "folw-id"])),
                      _createVNode(_component_a_form, _mergeProps({
                        layout: "vertical",
                        model: _unref(houseRent),
                        ref_key: "houseRentFormRef",
                        ref: houseRentFormRef
                      }, formItemLayout, {
                        validateTrigger: "blur",
                        class: ["form-upload", 
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              ]
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 0, 'FileUrl'],
                            label: "房屋租赁合同",
                            required: "",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(houseRent).PageFiles && _unref(houseRent).PageFiles.length > 0
                      ? _unref(houseRent).PageFiles[0]?.FileUrl
                      : ''
                  ,
                                "disable-close": !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value)),
                                disable: !!preData.value,
                                "file-type": '321',
                                onUpload: _cache[12] || (_cache[12] = (file) => handleUpload(file, 0))
                              }, null, 8, ["value", "disable-close", "disable"])
                            ]),
                            _: 1
                          }),
                          (
                  _unref(turn).PageFiles &&
                  _unref(turn).PageFiles.length > 0 &&
                  _unref(turn).PageFiles[0]?.FileUrl
                )
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                name: "turn",
                                label: "房屋租赁合同(回传)",
                                class: "form-upload-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Image, {
                                    value: 
                    _unref(turn).PageFiles && _unref(turn).PageFiles.length > 0
                      ? _unref(turn).PageFiles[0]?.FileUrl
                      : ''
                  ,
                                    "disable-close": true,
                                    disable: true,
                                    "file-type": '3211'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 1, 'FileUrl'],
                            label: "房产证复印件",
                            required: "",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(houseRent).PageFiles && _unref(houseRent).PageFiles.length > 1
                      ? _unref(houseRent).PageFiles[1]?.FileUrl
                      : ''
                  ,
                                "disable-close": !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value)),
                                disable: !!preData.value,
                                "file-type": '322',
                                onUpload: _cache[13] || (_cache[13] = (file) => handleUpload(file, 1))
                              }, null, 8, ["value", "disable-close", "disable"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "租赁备案（若有）",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(houseRent).PageFiles[2] && _unref(houseRent).PageFiles[2].FileUrl
                  ,
                                "disable-close": 
                    !(
                      WorkFlowId.value == 0 ||
                      IsFirstZLBAEdit.value ||
                      (IsZLBAEdit.value && reEdit.value)
                    )
                  ,
                                disable: !(!preData.value && (reEdit.value || _unref(edit))),
                                "file-type": '323',
                                onUpload: _cache[14] || (_cache[14] = (file) => handleUpload(file, 2))
                              }, null, 8, ["value", "disable-close", "disable"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "授权委托书（若有）",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(houseRent).PageFiles[3] && _unref(houseRent).PageFiles[3].FileUrl
                  ,
                                "disable-close": 
                    !(
                      WorkFlowId.value == 0 ||
                      IsFirstSQWTEdit.value ||
                      (IsSQWTEdit.value && reEdit.value)
                    )
                  ,
                                disable: !(!preData.value && (reEdit.value || _unref(edit))),
                                "file-type": '324',
                                onUpload: _cache[15] || (_cache[15] = (file) => handleUpload(file, 3))
                              }, null, 8, ["value", "disable-close", "disable"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "物业协议（若有）",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(houseRent).PageFiles[4] && _unref(houseRent).PageFiles[4].FileUrl
                  ,
                                "disable-close": 
                    !(
                      WorkFlowId.value == 0 ||
                      IsFirstWYXYEdit.value ||
                      (IsWYXYEdit.value && reEdit.value)
                    )
                  ,
                                disable: !(!preData.value && (reEdit.value || _unref(edit))),
                                "file-type": '325',
                                onUpload: _cache[16] || (_cache[16] = (file) => handleUpload(file, 4))
                              }, null, 8, ["value", "disable-close", "disable"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16, ["model", "class"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(currentStep) == 2)
                  ? (_openBlock(), _createBlock(_component_a_form, _mergeProps({
                      key: 2,
                      ref_key: "decproFormRef",
                      ref: decproFormRef,
                      layout: "vertical",
                      model: _unref(decpro)
                    }, formItemLayout, {
                      validateTrigger: "blur",
                      class: ["form-upload", 
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              ]
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "turn",
                          label: "房屋装修协议（若有）",
                          class: "form-upload-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              "disable-close": 
                    !(WorkFlowId.value == 0 || IsFirstFWZLEdit.value || reEdit.value)
                  ,
                              disable: !(!preData.value && (reEdit.value || _unref(edit))),
                              value: _unref(decpro).PageFiles[0] && _unref(decpro).PageFiles[0].FileUrl,
                              "file-type": '331',
                              onUpload: _cache[17] || (_cache[17] = (file) => handleUpload(file, 0))
                            }, null, 8, ["disable-close", "disable", "value"])
                          ]),
                          _: 1
                        }),
                        (
                  _unref(turnDecpro).PageFiles &&
                  _unref(turnDecpro).PageFiles.length > 0 &&
                  _unref(turnDecpro).PageFiles[0]?.FileUrl
                )
                          ? (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 0,
                              label: "房屋装修协议（回传）",
                              class: "form-upload-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  "disable-close": true,
                                  disable: true,
                                  value: 
                    _unref(turnDecpro).PageFiles[0] && _unref(turnDecpro).PageFiles[0].FileUrl
                  ,
                                  "file-type": '3311',
                                  onUpload: _cache[18] || (_cache[18] = (file) => handleUpload(file, 0))
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_form_item, {
                          name: ['PageFiles', 1, 'FileUrl'],
                          label: "办公用品采购协议（若有）",
                          class: "form-upload-item",
                          style: {"width":"170px"},
                          "label-col": { style: { whiteSpace: 'nowrap' } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              "disable-close": !(WorkFlowId.value == 0 || IsFirstCGEdit.value || reEdit.value),
                              disable: !(!preData.value && (reEdit.value || _unref(edit))),
                              "file-type": '332',
                              value: _unref(decpro).PageFiles[1] && _unref(decpro).PageFiles[1].FileUrl,
                              onUpload: _cache[19] || (_cache[19] = (file) => handleUpload(file, 1))
                            }, null, 8, ["disable-close", "disable", "value"])
                          ]),
                          _: 1
                        }),
                        (
                  _unref(turnDecpro).PageFiles &&
                  _unref(turnDecpro).PageFiles.length > 1 &&
                  _unref(turnDecpro).PageFiles[1]?.FileUrl
                )
                          ? (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 1,
                              label: "办公用品采购协议（回传）",
                              class: "form-upload-item",
                              style: {"width":"180px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  "disable-close": true,
                                  disable: true,
                                  "file-type": '3321',
                                  value: 
                    _unref(turnDecpro).PageFiles[1] && _unref(turnDecpro).PageFiles[1].FileUrl
                  
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 16, ["model", "class"]))
                  : _createCommentVNode("", true),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, { id: WorkFlowId.value }, null, 8, ["id"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: recallVisible.value,
              "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((recallVisible).value = $event)),
              title: "撤回理由",
              onOk: submitRecallSiteSelectionApply,
              onCancel: handleCancelResume
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"padding-left":"0"},
                  value: recallResume.value,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((recallResume).value = $event)),
                  bordered: false,
                  placeholder: "请填写撤回理由",
                  maxlength: 100,
                  "auto-size": { minRows: 5, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: recallVisible1.value,
              "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((recallVisible1).value = $event)),
              title: "撤回理由",
              onOk: setRecallTurnaroundHouseRentApply,
              onCancel: handleCancelResume
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"padding-left":"0"},
                  value: Reason1.value,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((Reason1).value = $event)),
                  bordered: false,
                  placeholder: "请填写撤回理由",
                  maxlength: 100,
                  "auto-size": { minRows: 5, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: recallVisible2.value,
              "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((recallVisible2).value = $event)),
              title: "撤回理由",
              onOk: setRecallTurnaroundHouseRentApply,
              onCancel: handleCancelResume
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"padding-left":"0"},
                  value: Reason2.value,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((Reason2).value = $event)),
                  bordered: false,
                  placeholder: "请填写撤回理由",
                  maxlength: 100,
                  "auto-size": { minRows: 5, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: _unref(turnRentVisible),
              "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => (_isRef(turnRentVisible) ? (turnRentVisible).value = $event : turnRentVisible = $event)),
              title: "房屋租赁合同回传",
              onOk: submitTurnaroundHouseRentApply,
              onCancel: _cache[28] || (_cache[28] = ($event: any) => (turnFormRef.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, _mergeProps({
                  ref_key: "turnFormRef",
                  ref: turnFormRef,
                  model: _unref(turn)
                }, formItemLayout, { validateTrigger: "blur" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      name: ['PageFiles', 0, 'FileUrl'],
                      label: "房屋租赁合同",
                      required: "",
                      class: "form-upload-item",
                      rules: [{ required: true, message: '请回传房屋租赁合同' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Image, {
                          value: 
                _unref(turn).PageFiles.length > 0 ? _unref(turn).PageFiles[0].FileUrl : ''
              ,
                          "disable-close": false,
                          onUpload: _cache[26] || (_cache[26] = (file) => handleUpload(file, 0)),
                          "file-type": '3211'
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16, ["model"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: _unref(turnDecproVisible),
              "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => (_isRef(turnDecproVisible) ? (turnDecproVisible).value = $event : turnDecproVisible = $event)),
              title: "装修、采购协议回传",
              onOk: submitTurnaroundDecproApply,
              onCancel: _cache[32] || (_cache[32] = ($event: any) => (turnDecproFormRef.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, _mergeProps({
                  ref_key: "turnDecproFormRef",
                  ref: turnDecproFormRef,
                  model: _unref(turnDecpro)
                }, formItemLayout, {
                  validateTrigger: "blur",
                  class: "back-upload"
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      name: ['PageFiles', 0, 'FileUrl'],
                      label: "房屋装修协议",
                      class: "form-upload-item",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Image, {
                          value: 
                _unref(turnDecpro).PageFiles.length > 0
                  ? _unref(turnDecpro).PageFiles[0].FileUrl
                  : ''
              ,
                          "disable-close": false,
                          "file-type": '3311',
                          onUpload: _cache[29] || (_cache[29] = (file) => handleUpload(file, 0))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      name: ['PageFiles', 1, 'FileUrl'],
                      label: "办公用品采购协议",
                      class: "form-upload-item",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Image, {
                          value: 
                _unref(turnDecpro).PageFiles.length > 0
                  ? _unref(turnDecpro).PageFiles[1].FileUrl
                  : ''
              ,
                          "file-type": '3321',
                          "disable-close": false,
                          onUpload: _cache[30] || (_cache[30] = (file) => handleUpload(file, 1))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16, ["model"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_a_modal, {
              visible: applyModalShow.value,
              "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((applyModalShow).value = $event)),
              centered: "",
              class: "applyModalClass",
              width: "430px",
              onOk: reapplyOk,
              onCancel: reapplyCancel
            }, {
              title: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"width":"22px","height":"22px","margin-right":"16px","margin-top":"-4px"},
                  src: require('../../assets/imgs/ProcessNode/warning-tip.png')
                }, null, 8, _hoisted_19),
                _hoisted_20
              ]),
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (actionButtons.value.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": actionButtons.value,
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})